import React, { useEffect } from "react";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";
import HomeHero, { HomeSupplement } from "@/components/home/HomeHero";
import HomeVideo from "@/components/home/HomeVideo";
import HomeCommonPoint from "@/components/home/HomeCommonPoint";
import HomeMission from "@/components/home/HomeMission";
import HomeConnectionAreas from "@/components/home/HomeConnectionAreas";
import HomeForrasKod from "@/components/home/HomeForrasKod";
import TestimonialsHighlight from "@/components/landing/TestimonialsHighlight";
import HomeHowToConnect from "@/components/home/HomeHowToConnect";
import { HomeUnity, HomeContact } from "@/components/home/HomeUnity";

const META_TITLE = "A családi dinamikák és az emberi kapcsolódások új dimenziója | Szász-Tóth Enikő";
const META_DESC =
  "Forrás-Kód® kísérés Szász-Tóth Enikővel. Az egység belül kezdődik, majd kapcsolódásról kapcsolódásra épül tovább. Új nézőpontok. Tiszta emberi értékek. Tudatos választások.";

export default function Home() {
  useEffect(() => {
    const prevTitle = document.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || null;
    document.title = META_TITLE;
    if (metaDesc) metaDesc.setAttribute("content", META_DESC);
    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc != null) metaDesc.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <main data-testid="home-page" className="bg-warm text-graphite min-h-screen">
      <Header />
      <HomeHero />
      <HomeVideo />
      <HomeSupplement />
      <HomeCommonPoint />
      <HomeMission />
      <HomeConnectionAreas />
      <HomeForrasKod />
      <TestimonialsHighlight testIdPrefix="home" sectionClassName="py-10 md:py-14 bg-warm" />
      <HomeHowToConnect />
      <HomeUnity />
      <HomeContact />
      <PageFooter />
    </main>
  );
}
